// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedDicom_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M2.14286 0H0V24H2.14286C9.24366 24 15 18.6274 15 12C15 5.37258 9.24366 0 2.14286 0Z" class="svg-bg"/>
  <path d="M3 16.4023V8H5.42578C8.52344 8 10.0723 9.36523 10.0723 12.0957C10.0723 13.3926 9.64258 14.4355 8.7832 15.2246C7.92383 16.0098 6.77148 16.4023 5.32617 16.4023H3ZM4.38867 9.18359V15.2246H5.50195C6.48242 15.2246 7.24414 14.9551 7.78711 14.416C8.33398 13.877 8.60742 13.1152 8.60742 12.1309C8.60742 10.166 7.58984 9.18359 5.55469 9.18359H4.38867Z" class="svg-fg"/>
</svg>
`;
/**
 * IconMedDicom is a generated icon component.
 */
let IconMedDicom = IconMedDicom_1 = class IconMedDicom extends IconBaseElement {
    render() {
        return html `${IconMedDicom_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedDicom.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedDicom = IconMedDicom_1 = __decorate([
    customElement('zui-icon-med-dicom')
], IconMedDicom);
export { IconMedDicom };
